import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import { MRT_ColumnFiltersState, MRT_SortingState } from "mantine-react-table";

interface DownloadVirtualAccountsCSVRequest {
  token: string;
  sorting?: MRT_SortingState;
  filter?: MRT_ColumnFiltersState;
  globalFilter?: string;
}

const downloadVirtualAccountsCSV = async ({
  token,
  sorting,
  filter,
  globalFilter,
}: DownloadVirtualAccountsCSVRequest) => {
  try {
    const params: Record<string, string> = {};

    if (sorting && sorting.length > 0) {
      params.sortBy = JSON.stringify({
        field: sorting[0].id,
        order: sorting[0].desc ? "desc" : "asc",
      });
    }

    if (filter && filter.length > 0) {
      params.filter = JSON.stringify(
        filter.map((f) => ({
          id: f.id,
          value: f.value,
        }))
      );
    }

    if (globalFilter) {
      params.globalFilter = globalFilter;
    }

    const response = await axios.get(
      `${getBaseUrl(Microservice.PAYMENT)}/payment/account/download-virtual-accounts-csv`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params,
        responseType: "blob",
        withCredentials: true,
      }
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default downloadVirtualAccountsCSV;
